import { FC } from "react";
import { useContent } from "../contexts/contentContext/contentContext.js";

interface TransformDatePropsI {
  date: string | Date;
  fullView?: boolean;
  showDay?: boolean;
  showTime?: boolean;
  shortNames?: boolean | null;
}

const month = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

const days = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export const getFirst3Letters = (str: string) => {
  return str.slice(0, 3);
};

export const useTransofrmedDate = ({
  date,
  fullView,
  showDay,
  shortNames = null,
}: TransformDatePropsI) => {
  const { getTextByKey } = useContent();
  const myDate = new Date(date!);
  const monthToShow =
    myDate.getMonth() < 9
      ? "0" + (myDate.getMonth() + 1)
      : myDate.getMonth() + 1;
  const dayToShow =
    myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate();

  const returnTime =
    myDate.getHours() +
    ":" +
    (myDate.getMinutes() < 10
      ? "0" + myDate.getMinutes()
      : myDate.getMinutes());

  const returnDate = fullView
    ? `${showDay ? getTextByKey(days[myDate.getDay()]) + ", " : ""}${
        shortNames
          ? getFirst3Letters(getTextByKey(month[myDate.getMonth()]))
          : getTextByKey(month[myDate.getMonth()]) + " " + myDate.getDate()
      }, ${myDate.getFullYear()}`
    : `${myDate.getFullYear()}-${monthToShow}-${dayToShow}`;

  return { returnTime, returnDate };
};

const GetTransformedDate: FC<TransformDatePropsI> = ({
  date,
  fullView = false,
  showDay = true,
  showTime = false,
  shortNames = false,
}) => {
  const { returnTime, returnDate } = useTransofrmedDate({
    date,
    fullView,
    showDay,
    shortNames,
  });
  if (!date) {
    return 0 as unknown as JSX.Element;
  }

  return (returnDate +
    (showTime ? " " + returnTime : "")) as unknown as JSX.Element;
};

export default GetTransformedDate;
